import * as React from "react";

const DangerousHtml = (props: any) => {
  return props.children ? (
    <div dangerouslySetInnerHTML={{ __html: props.children }} />
  ) : null;
};

export default DangerousHtml;
